import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'weight', 'weightUnit', 'reps', 'formula',
    'oneRepMax', 'displayUnit', 'formulaName',
    'pct95', 'pct90', 'pct85', 'pct80', 'pct75', 'pct70', 'pct65', 'pct60'
  ]

  connect() {
    this.calculate()
  }

  calculate() {
    const weight = parseFloat(this.weightTarget.value) || 135
    const unit = this.weightUnitTarget.value
    const reps = parseInt(this.repsTarget.value, 10) || 5
    const formula = this.formulaTargets.find((r) => r.checked)?.value || 'epley'

    // Calculate 1RM based on selected formula
    let oneRepMax

    if (reps === 1) {
      // If they entered 1 rep, the weight IS their 1RM
      oneRepMax = weight
    } else {
      switch (formula) {
        case 'epley':
          // Epley: weight × (1 + reps/30)
          oneRepMax = weight * (1 + reps / 30)
          break
        case 'brzycki':
          // Brzycki: weight × (36 / (37 - reps))
          oneRepMax = weight * (36 / (37 - reps))
          break
        case 'lombardi':
          // Lombardi: weight × (reps ^ 0.10)
          oneRepMax = weight * reps ** 0.10
          break
        default:
          oneRepMax = weight * (1 + reps / 30)
      }
    }

    // Round to nearest whole number
    oneRepMax = Math.round(oneRepMax)

    // Update display
    this.oneRepMaxTarget.textContent = oneRepMax
    this.displayUnitTarget.textContent = unit.toUpperCase()
    this.formulaNameTarget.textContent = this.getFormulaName(formula)

    // Calculate percentages
    this.pct95Target.textContent = Math.round(oneRepMax * 0.95)
    this.pct90Target.textContent = Math.round(oneRepMax * 0.90)
    this.pct85Target.textContent = Math.round(oneRepMax * 0.85)
    this.pct80Target.textContent = Math.round(oneRepMax * 0.80)
    this.pct75Target.textContent = Math.round(oneRepMax * 0.75)
    this.pct70Target.textContent = Math.round(oneRepMax * 0.70)
    this.pct65Target.textContent = Math.round(oneRepMax * 0.65)
    this.pct60Target.textContent = Math.round(oneRepMax * 0.60)
  }

  getFormulaName(formula) {
    const names = {
      epley: 'Epley',
      brzycki: 'Brzycki',
      lombardi: 'Lombardi'
    }
    return names[formula] || 'Epley'
  }
}
